import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är ett tillfälligt serveringstillstånd?";
const SHORT_ANSWER = "Ett tillfälligt tillstånd avser en enstaka tidsperiod eller ett enstaka tillfälle – t.ex. en festival, mässa eller företagsfest.";

export const Route = createFileRoute("/fraga/vad-ar-tillfalligt-tillstand")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är ett tillfälligt serveringstillstånd" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Tillfälligt tillstånd kan ges till allmänheten eller till slutet sällskap. Prövningen är mindre omfattande men kommunen tittar på arrangörens lämplighet, ordningshållning, ålderskontroll och lokalens säkerhet. Provet är 44 (allmänheten) resp. 28 (slutet) frågor."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/tillfalligt-serveringstillstand", label: "Tillfälligt tillstånd – komplett guide" }}
      related={[{"to": "/fraga/skillnad-stadigvarande-tillfalligt", "label": "Vad är skillnaden mellan stadigvarande och tillfälligt tillstånd?"}, {"to": "/fraga/cateringtillstand-vad-innebar-det", "label": "Vad innebär ett cateringtillstånd?"}, {"to": "/fraga/vad-ar-stadigvarande-tillstand", "label": "Vad är ett stadigvarande serveringstillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är ett tillfälligt serveringstillstånd?" },
      { name: "description", content: "Ett tillfälligt tillstånd avser en enstaka tidsperiod eller ett enstaka tillfälle – t.ex. en festival, mässa eller företagsfest." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-ar-tillfalligt-tillstand" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-ar-tillfalligt-tillstand" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-ar-tillfalligt-tillstand",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är ett tillfälligt serveringstillstånd", url: "https://alkoholprovet.se/fraga/vad-ar-tillfalligt-tillstand" },
      ]),
    ],
  }),
});
